module.exports = __webpack_public_path__ + "static/HyperCasual-ab0a98116030340eb5da8eb0f5dce628.png";